<nav aria-label="breadcrumb" class="xng-breadcrumb-root" [ngClass]="class">
  <ol class="xng-breadcrumb-list">
    <ng-container
      *ngFor="
        let breadcrumb of breadcrumbs$ | async;
        last as isLast;
        first as isFirst;
        index as index;
        count as count
      "
    >
      <li class="xng-breadcrumb-item">
        <a
          *ngIf="!isLast"
          (click)="handleRoute(breadcrumb)"
          (keydown.enter)="handleRoute(breadcrumb)"
          class="xng-breadcrumb-link"
          [ngClass]="{ 'xng-breadcrumb-link-disabled': breadcrumb.disable }"
          [attr.aria-disabled]="breadcrumb.disable"
          [attr.tabIndex]="breadcrumb.disable ? -1 : 0"
          role="button"
        >
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                $implicit: breadcrumb.label,
                info: breadcrumb.info,
                last: isLast,
                first: isFirst,
                index: index,
                count: count
              }
            "
          ></ng-container>
          <ng-container *ngIf="!itemTemplate">{{
            breadcrumb.label
            }}</ng-container>
        </a>

        <label *ngIf="isLast" class="xng-breadcrumb-trail">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                $implicit: breadcrumb.label,
                info: breadcrumb.info,
                last: isLast,
                first: isFirst,
                index: index,
                count: count
              }
            "
          ></ng-container>
          <ng-container *ngIf="!itemTemplate">{{
            breadcrumb.label
            }}</ng-container>
        </label>
      </li>

      <li
        *ngIf="!isLast"
        class="xng-breadcrumb-separator"
        aria-hidden="true"
        role="separator"
      >
        <ng-container *ngTemplateOutlet="separatorTemplate"></ng-container>
        <ng-container *ngIf="!separatorTemplate">{{ separator }}</ng-container>
      </li>
    </ng-container>
  </ol>
</nav>
